import _ from "lodash";

const Reference = (props) => {
    const { value } = props;

    return _.join(_.map(value, o => o.typeName + "#: " + o.number), ", ");
}

export default Reference;